/** Mobile top bar — interpolated between expanded and collapsed. */
export const MOBILE_TOPBAR_EXPANDED_PX = 58
export const MOBILE_TOPBAR_COLLAPSED_PX = 44

/** Desktop / layout: MUI content offset convention below app chrome. */
export const DESKTOP_TOOLBAR_SPACER_PX = 64
export const DESKTOP_TOPBAR_HEIGHT_PX = 58

/** Expanded mobile chrome height (topbar + spacer) — reference only. */
export const MOBILE_CHROME_TOTAL_PX = MOBILE_TOPBAR_EXPANDED_PX + DESKTOP_TOOLBAR_SPACER_PX

/** Logo / elevation micro-motion (ease-out; scroll-driven height uses lerp, not this). */
export const HEADER_MICRO_MOTION = '190ms ease-out'

function clamp01(p: number): number {
  return Math.min(1, Math.max(0, p))
}

export function getMobileTopbarHeightPx(progress: number): number {
  const p = clamp01(progress)
  return MOBILE_TOPBAR_EXPANDED_PX + (MOBILE_TOPBAR_COLLAPSED_PX - MOBILE_TOPBAR_EXPANDED_PX) * p
}

/**
 * MUI layout spacer below the app bar — fixed height.
 * When the top bar shrinks on scroll, this does **not** grow to compensate, so the top edge of
 * `#mainContainer` moves up and `position: sticky; top: 0` sections gain real viewport space.
 */
export function getMobileToolbarSpacerPx(_progress: number): number {
  void _progress
  return DESKTOP_TOOLBAR_SPACER_PX
}
